import { normalizeBasePath } from '@/Utils/Core/url';

export type WcRouterMode = 'history' | 'hash' | 'memory';

export function normalizeWcRouterMode(value: unknown): WcRouterMode {
  const normalized = typeof value === 'string' ? value.trim().toLowerCase() : '';
  return normalized === 'history' || normalized === 'hash' || normalized === 'memory'
    ? normalized
    : 'memory';
}

export function buildWcRouteHref({
  path,
  mode,
  basePath,
}: {
  path: string;
  mode: WcRouterMode;
  basePath: string;
}): string {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;

  if (mode === 'memory') return normalizedPath;
  if (mode === 'hash') return `#${normalizedPath}`;

  const normalizedBasePath = normalizeBasePath(basePath);
  return normalizedBasePath === '/' ? normalizedPath : `${normalizedBasePath}${normalizedPath}`;
}
